import cn from 'classnames';
import Head from 'next/head';
import { Link } from '@framework/router/Next/Link';
import Image404 from './assets/404.svg';

import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './pageNotFound.module.scss';

interface IProps {
  className?: string,
  title?: string,
  content?: React.ReactNode,
  button?: React.ReactNode,
}

const PageNotFound = ({
  className = '',
  title = 'Page not found',
  content = 'The page you are looking for could not be found.',
  button = (
    <Link to="/">
      <Button
        variant={ ButtonVariantType.text }
        className={ spacesStyles.mtxl }
        title="Back to Homepage"
        dataTest="backToHomePage"
      />
    </Link>
  ),
}: IProps) => (
  <>
    <Head>
      <title>{ title }</title>
    </Head>
    <div className={ cn(styles.container, className) }>
      <img
        className={ styles.backgroundImage }
        alt="Page not found"
        src={ Image404.src }
      />

      <h1 className={ cn(spacesStyles.mtxl, styles.title) }>
        Whoops...
      </h1>
      <h2 className={ cn(spacesStyles.mtxl, styles.subTitle) }>
        { content }
      </h2>
      { button }
    </div>
  </>
);

export default PageNotFound;
